import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Website} from "../../../../../websites/website/website";
import {fromEvent} from "rxjs/internal/observable/fromEvent";
import {filter, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {IDsDropdownOption} from "../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {FormControl} from "@angular/forms";

@Component({
    selector: 'db-create-website-install-websites-list',
    templateUrl: './create-website-install-websites-list.component.html',
    styleUrls: ['./create-website-install-websites-list.component.scss'],
    standalone: false
})
export class CreateWebsiteInstallWebsitesListComponent implements OnInit, OnDestroy {

  @Input() formSubmitted = false;
  @Input() websites: Website[] = [];
  @Input() selectedWebsite: Website;
  @Output() websiteSelected = new EventEmitter<number>();
  public toggled = false;
  public dropdownOptions: IDsDropdownOption[] = [
    {label: 'Live', value: 'live'},
    {label: 'Staging', value: 'dev'},
  ];
  public websiteType = new FormControl('live');

  private _destroyStream$ = new Subject<boolean>();

  constructor(
    private _element: ElementRef,
  ) { }

  ngOnInit() {
    this._hideOnClickOut();
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public toggleDropdown(): void {
    this.toggled = !this.toggled;
  }

  private _hideOnClickOut(): void {
    fromEvent(document, 'click')
      .pipe(
        takeUntil(this._destroyStream$),
        filter(e => !this._element.nativeElement.contains(e.target))
      )
      .subscribe(() => this.toggled = false);
  }

  public selectWebsite(websiteId: number): void {
    this.toggled = false;
    this.websiteType.setValue('live');
    this.websiteSelected.emit(websiteId);
  }

  public changeWebsiteEnv(): void {
    if (!this.selectedWebsite.siblingId) return;
    this.websiteSelected.emit(this.selectedWebsite.siblingId[this.websiteType.value]);
  }

}
